import React from "react";
import './Footer.css';
function Footer() {
  return (
    <footer>
      <h2>BLH Bauelemente für Lüftungstechnik Hennen GmbH       |       Tel.: +49 (0) 651 81 09 - 0      |      info@blh-trier.de</h2>
    </footer>
  );
}

export default Footer;

